import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "./context/cartContext"; // adjust path if needed
import "./index.css";
// import App from './mobile-app-development';
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
// import Service from "./pages/Service";
import ApplicationDevelopment from "./pages/ApplicationDevelopment";
import SocialMediaMarketing from "./pages/SocialMediaMarketing";
import ShopifyDevelopment from "./pages/ShopifyDevelopment";
import SoftwareDevelopment from "./pages/SoftwareDevelopment";
import PerformanceMarketing from "./pages/PerformanceMarketing";
import WebsiteDevelopment from "./pages/WebsiteDevelopment";
import SeoServices from "./pages/SeoServices";
import Pricing from "./pages/Pricing";
import Cart from "./pages/Cart";
// import GranobleApp from './pages/GranobleApp';
import Blog from "./pages/Blog";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import NotFoundPage from "./pages/NotFoundPage";
import store from "./apps/store";
// import CustomDevelopementService from './pages/SoftwareDevelopementServicePage';
// import WebDevelopementService from './pages/WebDevelopmentServicePage';
import DynamicServicePage from "./pages/DynamicServicePage";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


// resize-observer-fix.js
const originalRO = window.ResizeObserver;

class PatchedResizeObserver {
  constructor(callback) {
    this._ro = new originalRO((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
  observe(...args) {
    return this._ro.observe(...args);
  }
  unobserve(...args) {
    return this._ro.unobserve(...args);
  }
  disconnect(...args) {
    return this._ro.disconnect(...args);
  }
}

window.ResizeObserver = PatchedResizeObserver;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ToastContainer position="top-right" autoClose={3000} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            {/* <Route path="/services" element={<Service />} /> */}
            <Route
              path="/application-development"
              element={<ApplicationDevelopment />}
            />
            <Route
              path="/social-media-marketing"
              element={<SocialMediaMarketing />}
            />
            <Route
              path="/shopify-development"
              element={<ShopifyDevelopment />}
            />
            <Route
              path="/software-development"
              element={<SoftwareDevelopment />}
            />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/cart" element={<Cart />} />
            <Route
              path="/performance-marketing"
              element={<PerformanceMarketing />}
            />
            <Route
              path="/website-development"
              element={<WebsiteDevelopment />}
            />
            <Route path="/seo-services" element={<SeoServices />} />
            {/* <Route path="/granoble-app" element={<GranobleApp />} /> */}
            <Route path="/blog" element={<Blog />} />
            <Route
              path="/how-ai-is-revolutionizing-digital-marketing-trends-and-predictions"
              element={<Blog1 />}
            />
            <Route
              path="/the-future-of-digital-interaction-and-business"
              element={<Blog2 />}
            />
             {/* <Route path="/:slug" element={<CustomDevelopementService />} /> */}
             <Route path="/:slug" element={<DynamicServicePage />} />
             {/* <Route path="/:slug" element={<WebDevelopementService />} /> */}
             <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </Provider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
